const generateAdUnitPath = (
  slotName,
  size,
  suffix,
  section,
  article,
  advertSiteId
) => {
  /* 
  ⚠️ Looking for the Header Advert? See site\src\component\Structure\SiteContainer\index.jsx
  Linear: WEB-424, Ad Unit Renaming https://linear.app/bizclik-dev/issue/WEB-424/ad-unit-renaming
  Need the following:
  
  {site Id}/{section-slug} or {section.fullUrlPath}/{article/section}/{individual ad-size or type or other identifier}
  aim/robotics/landingpage-300x250 ...For an MPU on the page https://aimagazine.com/robotics
  aim/robotics/articlepage-300x250
  aim/robotics/articlepage-300x250 ...For an MPU on an article on https://aimagazine.com/robotics, e.g. https://aimagazine.com/data-and-analytics/democratising-data-atlan-reaches-us-750m-valuation
  aim/robotics/articlepage-728x90
  aim/robotics/videopage-970x250
  ...etc.

  ❓Use article Category? Some debate about this
  */

  const pathify = (str) =>
    str
      .toLowerCase()
      .replaceAll('&', 'and')
      .replaceAll(' ', '-')
      .replaceAll(/[^a-z0-9-&/]/g, '')
      .replaceAll('top10', 'list')

  const instanceSiteId = advertSiteId
    ? advertSiteId.toLowerCase()
    : 'instance-unset'

  const sectionFullUrlPath =
    section && section.fullUrlPath ? section.fullUrlPath : '/section-unset'

  // const sectionSiteId = section ? section.advertSectionId : 'zzz' // section.slug?
  // const articleSiteId = article ? article.advertSlotName : 'NoArticleSlotName' // Handle Landing page situation: no article slot names on Landing pages.

  let adSlotName = ''

  if (article) {
    // Content Page, e.g. Article, Video, List etc.
    // Note: some debate about whether or not to use articleCategory here or articleSlug
    const articleType =
      article && article.contentType
        ? article.contentType.toLowerCase().replace(' ', '-')
        : 'no-content-type' // The type of content, e.g. article, video, report, whitepaper, blog

    if (article.category) {
      const articleCategory = article
        ? article.category.toLowerCase().trim().replace(' ', '-')
        : 'no-article-category' // e.g. `robotics`, `ai-strategy`
      adSlotName =
        instanceSiteId +
        '/' +
        articleCategory +
        '/' +
        articleType +
        '-page-' +
        size
    } else {
      adSlotName = instanceSiteId + '/' + articleType + '-page-' + size
    }
  } else {
    // Section Page, including Home Page
    // Note: Home page - we need to handle the sectionFullURlPath which comes out as `/`
    if (section && section?.name === 'Home') {
      adSlotName = instanceSiteId + '/home/landing-page-' + size
    } else {
      adSlotName = instanceSiteId + sectionFullUrlPath + '/landing-page-' + size
    }
  }

  // Uncomment the following if you want to add a suffix to the adSlotName
  // if (suffix) {
  //   adSlotName += '-' + suffix
  // }

  adSlotName = pathify(adSlotName)

  return slotName || adSlotName
}

export default generateAdUnitPath

// 1. Replace top10 section.slug with list
//
